import React from 'react'
import { connect } from 'react-redux'
import css from './style.css'
import * as actions from '../../actions/search'
import SortDescIcon from 'react-icons/lib/fa/sort-desc'
import SortAscIcon from 'react-icons/lib/fa/sort-asc'

const ASC = 'asc'
const DESC = 'desc'
const FILTER_SORT_BY_FIELD = 'sortByField'
const FILTER_ORDER_BY = 'orderBy'

const mapStateToProps = (state, ownProps) => {
  return {
    ...state.diamondSearch
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClickSortableField: (field, order) => {
      dispatch(actions.setFilterVal(FILTER_SORT_BY_FIELD, field))
      dispatch(actions.setFilterVal(FILTER_ORDER_BY, order))
      dispatch(actions.setPageAndsearch())
    }
  }
}

const SortableHeader = (props) => {
  const displaySortIcon = () => {
    if (props.filters.sortByField !== props.fieldName) {
      return ''
    }
    if (props.filters.orderBy === ASC) {
      return <i><SortAscIcon /></i>
    }
    return <i><SortDescIcon /></i>
  }

  const getOrder = () => {
    if (props.filters.sortByField !== props.fieldName) {
      return ASC
    }
    if (props.filters.orderBy === ASC) {
      return DESC
    }
    return ASC
  }

  const handleClick = (e) => {
    e.preventDefault()
    props.onClickSortableField(props.fieldName, getOrder())
  }

  return (
    <div>
      <a href='#' onClick={e => handleClick(e)}>
        <div className={css.sortableHeader}>
          {props.title} {displaySortIcon()}
        </div>
      </a>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(SortableHeader)



// WEBPACK FOOTER //
// ./src/components/table/sortable_header.js